import React, { useEffect, useMemo } from "react";
import { Accordion, Nav, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { hasKeys, isAdminRole } from "../shared/utils";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAccess } from "../contexts/AccessContext";
// standalone access map fetched per user in this component


const accordionMap = {
  search: "1",
  "replace-search": "1",
  videos: "1",
  settings: "1",
  "summary-generation": "1",
  "transcript-generation": "1",

  "scribe-content-generate": "2",
  "scribe-contents": "2",
  "scribe-settings": "2",

  "pinging-video": "3",
  "pinging-web": "4",
  "assign-pinging-video": "5",
  "assign-pinging-web": "6",
  "assignment-content": "7",
  "course-content": "8",
  "standards-wizard": "10",
  "saved-courses": "10",
};

const Sidebar = ({
  isOpen,
  setIsSidebarOpen,
  toggleSidebar,
  location,
  params,
  onGenerateReset,
  onTranscriptReset,
}) => {
  const isAdmin = useMemo(() => isAdminRole(), []);
  const [activeAccordion, setActiveAccordion] = useState(null);

  const { hasView, hasEdit } = useAccess();

  const navigate = useNavigate();
  const rotateStyle = {
    transform: !isOpen ? "rotate(180deg)" : "none",
    transition: "transform 0.3s ease-in-out", // Optional: Adding transition for a smooth effect
  };
  const imageSize = isOpen ? 110 : 52; // Default size: 50px
  const imageStyle = {
    borderRadius: "50%",
    width: imageSize,
    height: imageSize,
    objectFit: "cover", // Ensure the image covers the entire container
  };
  useEffect(() => {
    // Session validation: ensure the user is still authenticated via OAuth2.
    // The old wstoken-based check is no longer valid after the OAuth2 migration.
    const isLoggedIn = localStorage.getItem("login");
    if (isLoggedIn !== "true") {
      navigate("/");
    }
  }, [navigate]);
  const sideBarActive = useMemo(() => {
    if (hasKeys(params) && hasKeys(params.action)) {
      return params.action;
    } else {
      return "";
    }
  }, [params]);

  useEffect(() => {
    const path = location.pathname.split("/").pop(); // e.g., "course-content"
    const key = accordionMap[path];
    if (key) setActiveAccordion(key);
  }, [location.pathname]);
  return (
    <div className={`sidebar p-2 ${isOpen ? "sidebar-open" : "close"}`}>
      <div className="sidebar-content">
        {isAdmin && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2 mb-2`}
          >
            <Accordion.Item eventKey="9">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/access-management.svg"} alt="user-module" />
                </div>
                {isOpen && <div>Access Management</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={sideBarActive === "user-module"}
                        as={Link}
                        to="/home/role-management"
                      >
                        Access Management
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}
        { (isAdmin || hasView(1)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"}`}
          >
            <Accordion.Item eventKey="1">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/videoFinderIcon.svg"} alt="video" />
                </div>
                {isOpen && <div>Video Finder</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link active={sideBarActive === "search"} as={Link} to="/home/search">
                        Search
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "replace-search"}
                        as={Link}
                        to="/home/replace-search"
                      >
                        Replace Search
                      </Nav.Link>
                      <Nav.Link active={sideBarActive === "videos"} as={Link} to="/home/videos">
                        Videos
                      </Nav.Link>
                      {(isAdmin || hasEdit(1)) && (
                        <Nav.Link
                          active={sideBarActive === "settings"}
                          as={Link}
                          to="/home/settings"
                        >
                          Settings
                        </Nav.Link>
                      )}
                      <Nav.Link
                        active={sideBarActive === "summary-generation"}
                        as={Link}
                        to="/home/summary-generation"
                      >
                        Summary Generation
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "transcript-generation"}
                        as={Link}
                        to="/home/transcript-generation"
                        onClick={() => {
                          if (location.pathname.includes("transcript-generation")) {
                            onTranscriptReset?.();
                          }
                        }}
                      >
                        Transcript Generation
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}
        {(isAdmin || hasView(2)) && (
          <Accordion className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}>
          <Accordion.Item eventKey="2">
            <Accordion.Header className="align-items-center">
              <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                <img src={"/images/video-guide.svg"} alt="video" />
              </div>
              {isOpen && <div>Video Guide</div>}
            </Accordion.Header>
            <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
              <Accordion.Body>
                {isOpen && (
                  <Nav className="flex-column accordion-menu-wrapper">
                    {(isAdmin || hasEdit(2)) && (
                      <Nav.Link
                        active={sideBarActive === "video-guide-default-settings"}
                        as={Link}
                        to="/home/video-guide-default-settings"
                      >
                        Settings
                      </Nav.Link>
                    )}
                    <Nav.Link
                      active={sideBarActive === "video-guide-settings"}
                      as={Link}
                      to="/home/video-guide-settings"
                    >
                      Search
                    </Nav.Link>
                    <Nav.Link
                      active={sideBarActive === "video-guide-report"}
                      as={Link}
                      to="/home/video-guide-report"
                    >
                      Report
                    </Nav.Link>
                  </Nav>
                )}
              </Accordion.Body>
            </div>
          </Accordion.Item>
        </Accordion>)}
        {(isAdmin || hasView(3)) && (
          <Accordion
          activeKey={activeAccordion}
          onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
          className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
        >
          <Accordion.Item eventKey="2">
            <Accordion.Header className="align-items-center">
              <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                <img src={"/images/scribe.svg"} alt="video" />
              </div>
              {isOpen && <div>Scribe AI Content</div>}
            </Accordion.Header>
            <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
              <Accordion.Body>
                {isOpen && (
                  <Nav className="flex-column accordion-menu-wrapper">
                    <Nav.Link
                      active={sideBarActive === "scribe-content-generate"}
                      as={Link}
                      to="/home/scribe-content-generate"
                      onClick={() => {
                        if (location.pathname.includes("scribe-content-generate")) {
                          onGenerateReset?.();
                        }
                      }}
                    >
                      Generate
                    </Nav.Link>
                    <Nav.Link
                      active={sideBarActive === "scribe-contents"}
                      as={Link}
                      to="/home/scribe-contents"
                    >
                      Generated content
                    </Nav.Link>
                    {(isAdmin || hasEdit(3)) && (
                      <Nav.Link
                        active={sideBarActive === "scribe-settings"}
                        as={Link}
                        to="/home/scribe-settings"
                      >
                        Settings
                      </Nav.Link>
                    )}
                  </Nav>
                )}
              </Accordion.Body>
            </div>
          </Accordion.Item>
        </Accordion>
        )}
        {(isAdmin || hasView(4)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          >
            <Accordion.Item eventKey="3">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/ping_video.svg"} alt="video" />
                </div>
                {isOpen && <div>Pinging Video</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={sideBarActive === "pinging-video" && params?.value === "good_video"}
                        as={Link}
                        to="/home/pinging-video?value=good_video"
                      >
                        Good
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "pinging-video" && params?.value === "bad_video"}
                        as={Link}
                        to="/home/pinging-video?value=bad_video"
                      >
                        Bad
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "pinging-video" && params?.value === "video_all"}
                        as={Link}
                        to="/home/pinging-video?value=video_all"
                      >
                        All
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "pinging-video" && params?.value === "downloaded"}
                        as={Link}
                        to="/home/pinging-video?value=downloaded"
                      >
                        Downloaded
                      </Nav.Link>
                      <Nav.Link
                        active={
                          sideBarActive === "pinging-video" && params?.value === "not_downloaded"
                        }
                        as={Link}
                        to="/home/pinging-video?value=not_downloaded"
                      >
                        Not Downloaded
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "pinging-video" && params?.value === "replaced"}
                        as={Link}
                        to="/home/pinging-video?value=replaced"
                      >
                        Replaced backup video
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}

        {(isAdmin || hasView(5)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          >
            <Accordion.Item eventKey="4">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/ping-web.svg"} alt="video" />
                </div>
                {isOpen && <div>Pinging Web</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={sideBarActive === "pinging-web" && params?.value === "good_web"}
                        as={Link}
                        to="/home/pinging-web?value=good_web"
                      >
                        Good
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "pinging-web" && params?.value === "bad_web"}
                        as={Link}
                        to="/home/pinging-web?value=bad_web"
                      >
                        Bad
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "pinging-web" && params?.value === "web_all"}
                        as={Link}
                        to="/home/pinging-web?value=web_all"
                      >
                        All
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}

        {(isAdmin || hasView(6)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          >
            <Accordion.Item eventKey="5">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/ping-ass-vid.svg"} alt="assign-video" />
                </div>
                {isOpen && <div>Assign Pinging - Video</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-video" && params?.value === "good_video"
                        }
                        as={Link}
                        to="/home/assign-pinging-video?value=good_video"
                      >
                        Good
                      </Nav.Link>
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-video" && params?.value === "bad_video"
                        }
                        as={Link}
                        to="/home/assign-pinging-video?value=bad_video"
                      >
                        Bad
                      </Nav.Link>
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-video" && params?.value === "video_all"
                        }
                        as={Link}
                        to="/home/assign-pinging-video?value=video_all"
                      >
                        All
                      </Nav.Link>
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-video" && params?.value === "downloaded"
                        }
                        as={Link}
                        to="/home/assign-pinging-video?value=downloaded"
                      >
                        Downloaded
                      </Nav.Link>
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-video" &&
                          params?.value === "not_downloaded"
                        }
                        as={Link}
                        to="/home/assign-pinging-video?value=not_downloaded"
                      >
                        Not Downloaded
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}

        {(isAdmin || hasView(7)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          >
            <Accordion.Item eventKey="6">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/ping-ass-web.svg"} alt="assign-web" />
                </div>
                {isOpen && <div>Assign Pinging - Web</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-web" && params?.value === "good_web"
                        }
                        as={Link}
                        to="/home/assign-pinging-web?value=good_web"
                      >
                        Good
                      </Nav.Link>
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-web" && params?.value === "bad_web"
                        }
                        as={Link}
                        to="/home/assign-pinging-web?value=bad_web"
                      >
                        Bad
                      </Nav.Link>
                      <Nav.Link
                        active={
                          sideBarActive === "assign-pinging-web" && params?.value === "web_all"
                        }
                        as={Link}
                        to="/home/assign-pinging-web?value=web_all"
                      >
                        All
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}
        {(isAdmin || hasView(8)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          >
            <Accordion.Item eventKey="7">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/ass-contents.svg"} alt="assignment-content" />
                </div>
                {isOpen && <div>Assignment Contents</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={sideBarActive === "assignment-content" && params?.value === "all"}
                        as={Link}
                        to="/home/assignment-content?value=all"
                      >
                        All
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "assignment-content" && params?.value === "video"}
                        as={Link}
                        to="/home/assignment-content?value=video"
                      >
                        Video
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "assignment-content" && params?.value === "web"}
                        as={Link}
                        to="/home/assignment-content?value=web"
                      >
                        Web
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}

        {(isAdmin || hasView(9)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          >
            <Accordion.Item eventKey="8">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/course-contents.svg"} alt="course-content" />
                </div>
                {isOpen && <div>Course Contents</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={sideBarActive === "course-content" && params?.value === "all"}
                        as={Link}
                        to="/home/course-content?value=all"
                      >
                        All
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "course-content" && params?.value === "video"}
                        as={Link}
                        to="/home/course-content?value=video"
                      >
                        Video
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "course-content" && params?.value === "web"}
                        as={Link}
                        to="/home/course-content?value=web"
                      >
                        Web
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}

        {(isAdmin || hasView(10)) && (
          <Accordion
            activeKey={activeAccordion}
            onSelect={(key) => setActiveAccordion(key === activeAccordion ? null : key)}
            className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
          >
            <Accordion.Item eventKey="10">
              <Accordion.Header className="align-items-center">
                <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                  <img src={"/images/standards-wizard.svg"} alt="standards-wizard" />
                </div>
                {isOpen && <div>Standards Wizard</div>}
              </Accordion.Header>
              <div className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}>
                <Accordion.Body>
                  {isOpen && (
                    <Nav className="flex-column accordion-menu-wrapper">
                      <Nav.Link
                        active={sideBarActive === "standards-wizard"}
                        as={Link}
                        to="/home/standards-wizard"
                      >
                        Create Course
                      </Nav.Link>
                      <Nav.Link
                        active={sideBarActive === "saved-courses"}
                        as={Link}
                        to="/home/saved-courses"
                      >
                        Saved Courses
                      </Nav.Link>
                    </Nav>
                  )}
                </Accordion.Body>
              </div>
            </Accordion.Item>
          </Accordion>
        )}

        {/* Question Bank — standalone accordion, external link */}
        <Accordion
          className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
        >
          <Accordion.Item eventKey="11">
            <Accordion.Header
              className="align-items-center"
              onClick={() => window.open("https://coursebuilder.svhs.co/qb/", "_blank")}
              style={{ pointerEvents: "auto" }}
            >
              <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                <img src={"/images/question.svg"} alt="question-bank" />
              </div>
              {isOpen && <div>Question Bank</div>}
            </Accordion.Header>
          </Accordion.Item>
        </Accordion>

        {/* Video Builder — standalone accordion, external link */}
        <Accordion
          className={`accordion-box ${isOpen ? "maximized" : "minimized"} mt-2`}
        >
          <Accordion.Item eventKey="12">
            <Accordion.Header
              className="align-items-center"
              onClick={() => window.open("https://ugc-dogs-ui.vercel.app/", "_blank")}
              style={{ pointerEvents: "auto" }}
            >
              <div className={`${isOpen ? "me-2" : "me-0"} ${isOpen ? "" : "mx-auto"}`}>
                <img src={"/images/play-circle.svg"} alt="video-builder" />
              </div>
              {isOpen && <div>Video Builder</div>}
            </Accordion.Header>
          </Accordion.Item>
        </Accordion>

        <div className="sidebar-bottum">
          <div className="dot-image">
            <Image
              src={sideBarActive.includes("scribe") ? "/images/scribe-dog.png" : "/images/Dot.png"}
              alt="User Profile"
              style={imageStyle}
            />
          </div>
          <div className="panel-trigger">
            <Button variant="link" className="p-0" onClick={toggleSidebar}>
              <img
                src={"/images/left_panel_open.svg"}
                style={rotateStyle}
                className="img-fluid"
                alt="panel"
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
